import { useTheme } from '@sds-system/system';
import type { ColorCode } from '@sds-system/types';
import { getColorValue } from '@sds-system/utils';
import { getSpinnerId } from './Spinner.const';
import type { SpinnerProps } from './Spinner.types';

export const ThreeDotBounce = ({ color, variant, activeColor, name, ...props }: SpinnerProps) => {
  const theme = useTheme();
  const { palette } = theme;

  const svgColor = getColorValue((color || palette.primary[100]) as ColorCode, theme);
  const svgActiveColor = getColorValue(
    (activeColor || palette.bg.interactive.primary) as ColorCode,
    theme,
  );

  const animateIdList = getSpinnerId(3, variant, name);

  return (
    <svg
      fill='none'
      height='48'
      viewBox='0 0 48 48'
      width='48'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='10' cy='24' fill={svgColor} r='4'>
        <animate
          attributeName='cy'
          begin={animateIdList[0]?.begin}
          dur='0.4s'
          id={animateIdList[0]?.id}
          values='24;14;24'
        />
        <animate
          attributeName='fill'
          begin={animateIdList[0]?.begin}
          dur='0.4s'
          from={svgColor}
          id={animateIdList[0]?.id}
          to={svgActiveColor}
        />
      </circle>
      <circle cx='24' cy='24' fill={svgColor} r='4'>
        <animate
          attributeName='cy'
          begin={animateIdList[1]?.begin}
          dur='0.4s'
          id={animateIdList[1]?.id}
          values='24;14;24'
        />
        <animate
          attributeName='fill'
          begin={animateIdList[1]?.begin}
          dur='0.4s'
          from={svgColor}
          id={animateIdList[1]?.id}
          to={svgActiveColor}
        />
      </circle>
      <circle cx='38' cy='24' fill={svgColor} r='4'>
        <animate
          attributeName='cy'
          begin={animateIdList[2]?.begin}
          dur='0.4s'
          id={animateIdList[2]?.id}
          values='24;14;24'
        />
        <animate
          attributeName='fill'
          begin={animateIdList[2]?.begin}
          dur='0.4s'
          from={svgColor}
          id={animateIdList[2]?.id}
          to={svgActiveColor}
        />
      </circle>
    </svg>
  );
};
